import { useTranslation } from 'react-i18next';
import { cn, PaletteUtils } from '@shared/utils';
import { Text } from '@shared/widgets';

type FooterProps = {
  className?: string;
};

export const Footer = (props: FooterProps) => {
  const { t } = useTranslation();

  return (
    <footer
      className={cn(
        'mt-auto flex w-full px-7 py-12 font-light',
        PaletteUtils.isInsigniaPalette && 'bg-very-pale-green dark:bg-gray-brown',
        PaletteUtils.isVcfcPalette && 'bg-twilight-dusk dark:bg-gray-brown',
        PaletteUtils.isPersonalPalette && 'bg-primary-700',
        props.className,
      )}
    >
      <div className='mx-auto flex max-w-[762px] flex-col gap-6 text-center'>
        <Text color={PaletteUtils.getColor(undefined, 'white')}>
          {t('footer.licensed')} <br />
          {t('footer.address')}
        </Text>
        <Text color={PaletteUtils.getColor(undefined, 'white')}>{t('footer.help')}</Text>
      </div>
    </footer>
  );
};
